<template>
    <the-jobs />
</template>

<script>
import TheJobs from "@/components/TheJobs.vue";

export default {
    components: {
        TheJobs,
    },
};
</script>

<style>
</style>